<template>
  <div class="row home-hot-event" >
    <div class="home-hot-event-left" v-if="title">
      <div class="hot-event-left">
        <div class="title" @click="navigate">{{title}}</div>
        <div class="count">{{count}}条相关新闻</div>
      </div>
      <div class="relevant-message">相关消息:</div>
      <div class="relevant-message-list" v-for="(item, index) in result" :key="index">
        <div>
          <div class="icon"></div>
          <span class="event-title"><a class="event-title-url" :href="item.url" target="_blank">{{item.title}}</a></span>
        </div>
        <span class="event-date">
          {{item.date}}
        </span>
      </div>                     
    </div>
    <div class="home-hot-event-right" v-if="title">
      <div class="hot-event-count">
        <div class="hot-event-title">事件影响力评分(分)</div>
        <div class="hot-event-index">{{heat}}</div>
      </div>
      <div class="event-trend">
        <div class="event-trend-title">事件热度趋势(度)</div>
        <div class="chart">
          <HomeHotEventChart :data="topOne" v-if="topOne"></HomeHotEventChart>
        </div>
        <div class="event-trend-bottom"></div>
        <div class="row event-trend-date">
          <div>{{date[0]}}</div>
          <div>{{date[date.length-1]}}</div>
        </div>
      </div>
    </div>
    <div class="no-data-container" v-if="!title">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import HomeHotEventChart from '@/components/news-monitor/HomeHotEventChart';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import NoData from '@/components/common/NoData';

export default {
  data() {
    return {
      reg: '',
      id: '',
      username: '',
      topOne: null,
      title: '中国益公司关注最社会企业中国益公司关注最社会企业',
      count: 112,
      heat: 91,
      result: [],
      timer: null,
      date: ''
    };
  },
  methods: {
    navigate() {
      this.$router.push({
        name: 'event-detail',
        query: {
          name: this.title,
          id: this.id
        }
      });
    },
    getHomeHotEvents() {
      QuestionQuery.homeHotEvents(this.username).then(res => {
        this.topOne = res.topOne;
        this.id = res.topOne.id;
        this.title = res.topOne.title;
        this.count = res.topOne.count;
        this.result = res.topOne.newsList;
        this.heat = res.topOne.heat;
        this.date = res.topOne.fields;
      }); 
    }
  },
  components: {
    HomeHotEventChart,
    NoData
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getHomeHotEvents();
    this.timer = window.setInterval(() => {
      this.getHomeHotEvents();
    }, 1000 * 60);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);        
    }
  }
};
</script>

<style lang="scss" scoped>
.home-hot-event {
  position: relative;
  padding: 24px 28px 16px 24px;
  height: 225px;
  background-color: #3e3c42;
  font-size: 14px;
  .home-hot-event-left {
    flex: 1;
    margin-right: 44px;
    .hot-event-left {
      padding-bottom: 24px;
      .title {
        font-size: 20px;;
        color: #ffffff;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .count {
        padding-top: 16px;
        color: #ffffff;
      }
    }
    .relevant-message {
      margin-bottom: 16px;
      color: rgba(255, 255, 255, 0.6);
    }
    .relevant-message-list {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      .icon {
        display: inline-block;
        width: 4px;
        height: 4px;
        margin-right:6px;
        border-radius: 50%;
        background-color: #45a8cc;
        vertical-align:middle;
      }
      .event-title {
        display: inline-block;
        color:#ffffff;
        font-size: 14px;
        width: 324px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align:middle;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
        .event-title-url {
          color:#ffffff;
          text-decoration: none;
        }
      }
      .event-date {
        padding-top: 3px;
        color: rgba(255, 255, 255, 0.6);
        font-size: 12px;
      }
    }
  }
  .home-hot-event-right {
    width: 234px;
    .hot-event-count {
      display: flex;
      justify-content: space-between;
      .hot-event-title {
        padding-top: 22px;
        color: rgba(255, 255, 255, 0.8);
        font-size: 12px;
      }
      .hot-event-index {
        color: #ffe536;
        font-size: 32px;
        font-family: Roboto-MediumItalic;
      }
    }
    .event-trend {
      margin-top: 14px;
      .event-trend-title {
        padding-bottom: 4px;
        border-bottom: 1px solid #656164;
        font-size: 12px;
        color: #ffffff;
      }
      .chart {
        width: 100%;
        height: 86px;
        background-color: #3e3c42;
      }
      .event-trend-bottom {
        border-bottom: 1px solid #656164;
      }
      .event-trend-date {
        justify-content: space-between;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
  .no-data-container {
    position: absolute;
    top: 57%;
    left: 50%;
    transform: translate(-50%, -50%);
    .no-data {
      font-size: 18px;
    }
  }
}
</style>

